import React from 'react';
import ReactDOM from 'react-dom/client';
import './GlobalStyles.css';
import App from './App';
import axios from 'axios';
import { fixObjectEncoding } from './utils/encodingUtils';

// Configuração global do axios para UTF-8
axios.defaults.headers.common['Accept'] = 'application/json; charset=utf-8';
// NÃO forçar responseType globalmente - deixar cada requisição definir o seu

// Não forçar JSON quando a requisição usa FormData (upload de arquivos/fotos)
axios.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers['Content-Type'];
        delete config.headers.common?.['Content-Type'];
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor global para corrigir codificação
axios.interceptors.response.use(
  (response) => {
    // NÃO processar respostas binárias (PDFs, imagens, etc)
    const contentType = response.headers['content-type'] || '';
    const isBinary = contentType.includes('application/pdf') || 
                     contentType.includes('image/') || 
                     contentType.includes('application/octet-stream') ||
                     contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                     contentType.includes('application/vnd.ms-excel');
    
    // Apenas corrige codificação em respostas JSON
    if (!isBinary && response.data && typeof response.data === 'object') {
      response.data = fixObjectEncoding(response.data);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);